import { render } from "./Colors.vue?vue&type=template&id=b874797c"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"
script.render = render

export default script